
export class LocationTableObject {

  constructor(private id: number, private name: string, private role: string, private numberOfContacts: number) {
  }

  public static create() {
    return new LocationTableObject(0, '', '', 0);
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getRole(): string {
    return this.role;
  }

  public getNumberOfContacts(): number {
    return this.numberOfContacts;
  }
}
